import type { IconNode } from '../types';

/**
 * @name pear
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgN2E0Ljk1IDQuOTUgMCAwIDAtOC42LTMuNGMtMS41IDEuNi0xLjYgMS44LTUgMi42YTggOCAwIDEgMCA5LjQgOS41Yy43LTMuNCAxLTMuNiAyLjYtNSAxLTEgMS42LTIuMyAxLjYtMy43IiAvPgogIDxwYXRoIGQ9Im0xOSA1IDMtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/pear
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pear: IconNode = [
  [
    'path',
    {
      d: 'M22 7a4.95 4.95 0 0 0-8.6-3.4c-1.5 1.6-1.6 1.8-5 2.6a8 8 0 1 0 9.4 9.5c.7-3.4 1-3.6 2.6-5 1-1 1.6-2.3 1.6-3.7',
      key: '17raaj',
    },
  ],
  ['path', { d: 'm19 5 3-3', key: 'yk6iyv' }],
];

export default pear;
